import { Observable } from 'rxjs';
import { SnEnvService } from '@insight/serenity-env';
import { HttpService } from '../services/http.service';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { SFClientRegistryService } from '../shared/api/services';

@Injectable({
  providedIn: 'root'
})
export class FilePortalDataService {
  constructor(
    private _httpService: HttpService,
    private _envService: SnEnvService,
    private _sfClientRegistryService: SFClientRegistryService) {

  }
  // #region Methods
  getAttachment(id: string): Observable<any> {
    const url = this._envService.get('api_url') + 'attachment/' + id;
    return this._httpService.get<any>(url);
  }

  // ---------------------------------------------------

  async getAviClientRegistry(continuationToken?: string): Promise<any> {
    let results = await this._sfClientRegistryService.GetAllSFClientRegistries().toPromise();
    return results;
  }

  // ---------------------------------------------------

  getInvoicesByClientId(id: string, continuationToken?: string): Observable<any> {
    let url = this._envService.get('api_url') + 'clientBillingInvoice' + '?filter=clientid:' + id;
    if (continuationToken) {
      url += '&continuationToken=' + encodeURIComponent(continuationToken);
    }
    return this._httpService.get<any>(url);
  }

  // ---------------------------------------------------

  getBackUpFilesByClientId(id: string, continuationToken?: string): Observable<any> {
    let url = this._envService.get('api_url') + 'backupfiles/' + 'aviID/' + id;
    if (continuationToken) {
      url += '?continuationToken=' + encodeURIComponent(continuationToken);
    }
    return this._httpService.get<any>(url);
  }


  downloadFileFromBlob(fullFilePath: string): Observable<any> {
    const url = `${this._envService.get('api_url')}fileportal/downloadfilefromblob?fullFilePath=${encodeURIComponent(fullFilePath)}`;
    const httpOption: Object = {
      observe: 'response',
      responseType: 'blob'
    };

    return this._httpService.get<any>(url, httpOption);
  }

  // ---------------------------------------------------

  getAllFileNamesForClientInBlob(model: any): Observable<any> {
    let url = `${this._envService.get('api_url')}fileportal/getallfilenamesforclientinblob/${model.year}/${model.month}/${model.clientId}`;
    return this._httpService.get<any>(url);
  }
  // #engregion
}
